"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CODEGEN_SCALAR_TYPES = exports.ADD_ON_CATEGORIES = exports.SET_GUEST = exports.PER_GUEST = exports.SET_DAY = exports.PER_DAY = exports.UserTrackingPropertyName = exports.ValuePropertyName = void 0;
var ValuePropertyName;
(function (ValuePropertyName) {
    ValuePropertyName["BooleanValue"] = "boolean_value";
    ValuePropertyName["NumberValue"] = "number_value";
    ValuePropertyName["StringValue"] = "string_value";
})(ValuePropertyName || (exports.ValuePropertyName = ValuePropertyName = {}));
var UserTrackingPropertyName;
(function (UserTrackingPropertyName) {
    UserTrackingPropertyName["DashboadVersion"] = "dashboardVersion";
    UserTrackingPropertyName["FirstName"] = "firstName";
    UserTrackingPropertyName["HasListings"] = "hasListings";
    UserTrackingPropertyName["HasTapToPayAccess"] = "hasTapToPayAccess";
    UserTrackingPropertyName["LastName"] = "lastName";
    UserTrackingPropertyName["MobileVersion"] = "mobileVersion";
    UserTrackingPropertyName["WebVersion"] = "webVersion";
})(UserTrackingPropertyName || (exports.UserTrackingPropertyName = UserTrackingPropertyName = {}));
exports.PER_DAY = "PER_DAY";
exports.SET_DAY = "SET_DAY";
exports.PER_GUEST = "PER_GUEST";
exports.SET_GUEST = "SET_GUEST";
exports.ADD_ON_CATEGORIES = {
    GUN_RENTAL: "GUN_RENTAL",
    MEAL_UPGRADE: "MEAL_UPGRADE",
    OTHER: "OTHER",
    TROPHY: "TROPHY",
};
exports.CODEGEN_SCALAR_TYPES = {
    Timestamp: "number",
    TimeZone: "string",
    EmailAddress: "string",
    NonEmptyString: "string",
    NegativeFloat: "number",
    NegativeInt: "number",
    NonNegativeFloat: "number",
    NonNegativeInt: "number",
    NonPositiveFloat: "number",
    NonPositiveInt: "number",
    PhoneNumber: "string",
    PositiveFloat: "number",
    PositiveInt: "number",
    PostalCode: "string",
    UnsignedFloat: "number",
    UnsignedInt: "number",
    URL: "string",
    Latitude: "number",
    Longitude: "number",
};
